/**
 * Module NEUTRE « video-hero » — KEEP IN SYNC avec
 * inventozen-frontpublic/src/cms-puck/video-hero.ts
 */
export type VideoHeroOverlay = "none" | "light" | "dark";

export const VIDEO_HERO_OVERLAY_CLASS: Record<VideoHeroOverlay, string> = {
  none: "",
  light: "bg-white/30",
  dark: "bg-black/45",
};

export function normalizeVideoHeroOverlay(value: unknown): VideoHeroOverlay {
  const v = String(value ?? "");
  if (v === "none" || v === "light" || v === "dark") return v;
  return "dark";
}

export function normalizeVideoHeroHeight(value: unknown): number {
  const n = Number(value);
  if (!Number.isFinite(n) || n < 240) return 480;
  if (n > 900) return 900;
  return Math.round(n);
}
